import type { FC, ReactNode } from 'react';
import { useClientSettings } from '../../hooks';
import isApplePayCompatible from '../../utils/applePay/isApplePayCompatible';

interface ConditionalRenderBasedOnClientSettingsProps {
    children: ReactNode;
}

const ConditionalRenderBasedOnClientSettings: FC<ConditionalRenderBasedOnClientSettingsProps> = ({ children }) => {
    const clientSettings = useClientSettings();

    const expressCheckoutOptions = clientSettings.expressCheckoutOptions ?? {
        klarnaExpressCheckoutEnabled: false,
        paypalExpressCheckoutEnabled: false,
        applePayExpressCheckoutEnabled: false,
    }; // default values because they don't exist until client settings are fetched

    const {
        klarnaExpressCheckoutEnabled,
        paypalExpressCheckoutEnabled,
        applePayExpressCheckoutEnabled,
    } = expressCheckoutOptions;

    const isAnyExpressCheckoutEnabled = [
        klarnaExpressCheckoutEnabled,
        paypalExpressCheckoutEnabled,
        applePayExpressCheckoutEnabled && isApplePayCompatible(),
    ].some(Boolean);

    if (!isAnyExpressCheckoutEnabled) {
        return null;
    }

    return <>{children}</>;
};

export default ConditionalRenderBasedOnClientSettings;
